import { FormHelperText as MuiFormHelperText } from '@mui/material'
import styled from '@emotion/styled'
import { FormHelperTextProps } from './FormHelperText.types'

export const FormHelperText = styled(MuiFormHelperText)<FormHelperTextProps>`
  color: ${({ theme, error }) => theme.palette[error ? 'error' : 'info'].main};
  letter-spacing: -0.5px;
  font-size: 12px;
  line-height: 12px;
  margin: 0;
`
